module.exports = __webpack_public_path__ + "img/l.1f96d7ff.jpg";